'use client';

import { c as _c } from "react/compiler-runtime";
import { RocketIcon } from 'lucide-react';
import * as m from 'motion/react-m';
import { useTranslations } from 'next-intl';
import { buttonVariants } from '@/components/ui/button';
import { useRouter } from '@/i18n/navigation';
import { cn } from '@/lib/utils';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.3
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring' as const,
      stiffness: 100,
      damping: 12
    }
  }
};
export function Home() {
  const $ = _c(21);
  const t = useTranslations("home_page");
  const router = useRouter();
  let t0;
  if ($[0] !== router) {
    t0 = () => {
      router.push("/playground");
    };
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleClickExplore = t0;
  let t1;
  if ($[2] !== t) {
    t1 = t("development.title");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <m.h2 variants={itemVariants} className="bg-linear-to-r from-accent-violet via-accent-sky to-accent-amber bg-clip-text font-bold text-4xl text-transparent">{t1}</m.h2>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("development.subtitle");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <m.p variants={itemVariants} className="text-lg text-muted-foreground">{t3}</m.p>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = cn(buttonVariants({
      size: "lg"
    }), "h-12 cursor-pointer bg-linear-to-r from-accent-sky to-accent-sky-dark px-6 text-base text-white shadow-accent-sky/25 shadow-lg transition-all hover:scale-[1.005] hover:shadow-accent-sky/30 hover:shadow-xl active:scale-95");
    t6 = <RocketIcon className="size-5" />;
    $[10] = t5;
    $[11] = t6;
  } else {
    t5 = $[10];
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t("development.playground_cta");
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== handleClickExplore || $[15] !== t7) {
    t8 = <m.button onClick={handleClickExplore} variants={itemVariants} className={t5}>{t6}{t7}</m.button>;
    $[14] = handleClickExplore;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t2 || $[18] !== t4 || $[19] !== t8) {
    t9 = <m.div className="mx-auto mt-8 flex max-w-7xl flex-col gap-4 p-4 sm:mt-32 sm:max-w-md sm:flex-row" variants={containerVariants} initial="hidden" animate="visible"><div className="flex flex-1 flex-col gap-12"><div className="flex flex-col items-start gap-4">{t2}{t4}{t8}</div></div></m.div>;
    $[17] = t2;
    $[18] = t4;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}